module.exports = __webpack_public_path__ + "static/patriciawork2-18bf5b58649e072c4d63141a4fc713db.jpg";